export const IDS = {
  // Auth
  loginBtn: "login-google-btn",
  logoutBtn: "logout-btn",

  // Onboarding
  nameInput: "onb-name-input",
  genderSelect: "onb-gender-select",
  ageInput: "onb-age-input",
  bodyPhotoInput: "onb-body-photo-input",
  measHeight: "onb-height-input",
  measWeight: "onb-weight-input",
  measShoulder: "onb-shoulder-input",
  measWaist: "onb-waist-input",
  measHip: "onb-hip-input",
  onbNext: "onb-next-btn",
  onbFinish: "onb-finish-btn",
  onbSkipPhoto: "onb-skip-photo-btn",

  // Home
  weatherStrip: "home-weather-strip",
  styleMeBtn: "home-style-me-btn",
  occasionChip: (o) => `occasion-chip-${o}`,
  moodChip: (m) => `mood-chip-${m}`,
  chatEntry: "home-chat-entry-btn",
  homeCloset: "home-closet-count",

  // Closet
  closetUploadBtn: "closet-upload-btn",
  closetUploadInput: "closet-upload-input",
  closetItem: (id) => `closet-item-${id}`,
  closetGrid: "closet-grid",

  // Outfit
  outfitCard: "outfit-card",
  outfitAnother: "outfit-another-btn",
  outfitWore: "outfit-wore-btn",
  outfitThumbUp: "outfit-thumb-up",
  outfitThumbDown: "outfit-thumb-down",
  outfitWhy: "outfit-why",

  // Chat
  chatInput: "chat-input",
  chatSend: "chat-send-btn",
  chatMessage: (idx) => `chat-msg-${idx}`,

  // Nav
  navHome: "nav-home",
  navCloset: "nav-closet",
  navChat: "nav-chat",
  navProfile: "nav-profile",

  // Events
  eventsNewBtn: "events-new-btn",
  eventCard: (id) => `event-card-${id}`,
  eventName: "event-name-input",
  eventDate: "event-date-input",
  eventOccasion: "event-occasion-input",
  eventWithWhom: "event-with-whom-input",
  eventDressCode: "event-dresscode-input",
  eventCreateBtn: "event-create-btn",
  eventOptionCard: (idx) => `event-option-${idx}`,
  eventChooseBtn: (idx) => `event-choose-${idx}`,
  eventRegenBtn: "event-regen-btn",
  eventDeleteBtn: "event-delete-btn",
  eventEditBtn: "event-edit-btn",
};
